import React from 'react';
import { useThemeClasses } from '../../hooks/useThemeClasses';

export default function AdminKpi({ icon: Icon, label, value, hint, onClick }) {
  const tc = useThemeClasses();
  const interactive = typeof onClick === 'function';
  const Wrapper = interactive ? 'button' : 'div';

  return (
    <Wrapper
      type={interactive ? 'button' : undefined}
      onClick={onClick}
      className={`rounded-2xl p-4 border text-left ${tc.box} ${interactive ? 'transition-colors hover:border-[#1F80FF]/40' : ''}`}
    >
      <div className="flex items-start justify-between mb-3">
        {Icon ? (
          <div className={`w-9 h-9 rounded-xl flex items-center justify-center ${tc.modoOscuro ? 'bg-gray-800 text-white' : 'bg-gray-900 text-white'}`}>
            <Icon className="w-4 h-4" />
          </div>
        ) : null}
      </div>
      <div className={`text-2xl font-semibold tabular-nums ${tc.textPri}`}>{value}</div>
      <div className={`text-xs font-medium mt-1 ${tc.textSec}`}>{label}</div>
      {hint ? <div className={`text-[11px] mt-2 ${tc.textMuted}`}>{hint}</div> : null}
    </Wrapper>
  );
}

export function AdminKpiGrid({ items = [] }) {
  if (!items.length) return null;
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      {items.map((item) => (
        <AdminKpi key={item.label} {...item} />
      ))}
    </div>
  );
}
